import { useCallback } from "react";
import { useLocation } from "react-router";

/** キャンペーン公開時にゲストへメールが送られる旨の確認（window.confirm 用） */
const CAMPAIGN_PUBLISH_CONFIRM_MESSAGE =
	"公開すると、登録済みのゲストへメールが送信されます。\nこのまま公開してよろしいですか？";

type Props = {
	inSale: boolean;

	hasError: boolean;
	isDirty: boolean;

	onPublish: () => void;
};

export const usePublish = ({ inSale: _inSale, hasError, isDirty, onPublish: _onPublish }: Props) => {
	const location = useLocation();
	const isNew = location.pathname.includes("new");
	const isValid = !hasError && isDirty;

	const onPublish = useCallback(() => {
		if (!window.confirm(CAMPAIGN_PUBLISH_CONFIRM_MESSAGE)) {
			return;
		}
		_onPublish();
	}, [_onPublish]);

	return {
		inSale: _inSale,
		isValid,
		isNew,
		onPublish,
	};
};
